module.exports = __webpack_public_path__ + "static/media/1920-service-1-4-min.7f0da756.jpg";